import httpRequest from '@/utils/request';
import axios from 'axios';


const CancelToken = axios.CancelToken;
const requirementUrl = '/Requirement';

const generateUrlByRequirementId = (id: string): string => {
  return `${requirementUrl}/${id}`;
};
const updateStatusUrl = (id: string): string => {
  return `${requirementUrl}/${id}/status`;
};
export let cancel: any;

export const getRequirements = (
  params: IRequirement.IRequest.IGetRequirement,
  ): Promise<IRequirement.IResponse.IData> => {
    return httpRequest.get(requirementUrl, {
      params,
    });
};

export const getRequirementById = (
  params: IRequirement.IRequest.IGetRequirement,
): Promise<IRequirement.IResponse.IData> => {
  return httpRequest.get(requirementUrl, {
    params,
    cancelToken: new CancelToken((c) => {
      cancel = c;
    }),
  });
};

export const updateRequirement = (
  params: IRequirement.IRequest.ICreateOrUpdateRequirement,
): Promise<IResponseData.IBaseData> => {
  const url = generateUrlByRequirementId(params.id);
  return httpRequest.post(url, params.data);
};

export const delRequirement = (id: string): Promise<IResponseData.IBaseData> => {
  const url = generateUrlByRequirementId(id);
  return httpRequest.delete(url);
};

export const approveRequirement = (id: string): Promise<IResponseData.IBaseData> => {
  const url = updateStatusUrl(id);
  return httpRequest.put(url, null, {
    params: {
      status: 'Approved',
    },
  });
};
export const rejectRequirement = (id: string): Promise<IResponseData.IBaseData> => {
  const url = updateStatusUrl(id);
  return httpRequest.put(url, null, {
    params: {
      status: 'Rejected',
    },
  });
};
export const cancelRequirement = (id: string): Promise<IResponseData.IBaseData> => {
  const url = updateStatusUrl(id);
  return httpRequest.put(url, null, {
    params: {
      status: 'Cancel',
    },
  });
};
export const closeRequirement = (id: string): Promise<IResponseData.IBaseData> => {
  const url = updateStatusUrl(id);
  return httpRequest.put(url, null, {
    params: {
      status: 'Closed',
    },
  });
};
